<br>
<div>
    <p-table #dt [columns]="cols" [value]="signtypes" [paginator]="false" [autoLayout]="true">
        <ng-template pTemplate="caption">
            <p class="rubrik">Sign Type</p>
            
            <div class="d-flex d-justify-content-start gap-2"><button class="btn border" (click)="resetFilter()" title="Rensa filter">Rensa filter</button><button class="btn border"
                             (click)="exportToCSV()">Excel</button><button class="btn border" (click)="addCommittee();">Lägg till</button></div>
            <br>
            <div>
                <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
                <input type="text" #globalfilter pInputText size="50" placeholder="Globalt filter" (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">
            <span class="ms-2">Antal poster: {{signtypes?.length}}</span>
            </div>

           
        </ng-template>
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
                <th>Action</th>
            </tr>
            <tr>
                <th *ngFor="let col of columns" [ngSwitch]="col.field">
                    <input *ngSwitchCase="'name'" pInputText type="text" [value]="dt.filters['name'] ? dt.filters['name'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
                    <input *ngSwitchCase="'sort'" pInputText type="text" [value]="dt.filters['sort'] ? dt.filters['sort'].value : ''" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:100%">
                </th>
                <th style="text-align: center;"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-i="rowIndex" let-columns="columns">
            <tr [pSelectableRow]="rowData">
                <td *ngFor="let col of columns">
                    {{rowData[col.field]}}
                </td>
                <td style="text-align: center;"><span style="display: inline-block;"><i class="fa fa-trash" style="font-size:12px;" (click)="removeConfirmDialog(rowData)" title="Radera"></i><i class="fa fa-edit ms-2" style="font-size:12px;" (click)="edit(rowData)"
                            title="Ändra utmärkelsetyp"></i></span></td>
            </tr>
        </ng-template>
    </p-table>
</div>

<p-dialog header="Editera utmärkelsetyp" [(visible)]="display" [closable]="true" appendTo="body" position="center" modal="true" maximizable="true">
    <app-admin-sign-type-edit [formdata]="formdata" (doSave)="saveSignType($event)" (doCancel)="cancelEdit()"></app-admin-sign-type-edit>
</p-dialog>

<p-dialog header="Lägg till utmärkelsetyp" [(visible)]="displayaddsigntype" [closable]="true" appendTo="body" position="center" modal="true" maximizable="true">
    <app-admin-sign-type-add [formdata]="formdata" (doSave)="saveAddSignType($event)" (doCancel)="cancelAdd()"></app-admin-sign-type-add>
</p-dialog>